import { Routes } from '@models/route';
import { lazy } from 'react';

const ListEngineers = lazy(() =>
  import('@pages/engineers/list-engineers').then((p) => ({
    default: p.ListEngineers
  }))
);

const CreateEngineer = lazy(() =>
  import('@pages/engineers/create-engineer').then((p) => ({
    default: p.CreateEngineer
  }))
);

const ViewEngineer = lazy(() =>
  import('@pages/engineers/view-engineer').then((p) => ({
    default: p.ViewEngineer
  }))
);

export const EngineerRoutes: Routes = [
  {
    path: '/Engineers',
    component: ListEngineers,
    children: [
      {
        path: 'create',
        component: CreateEngineer
      },
      {
        path: ':id',
        component: ViewEngineer
      }
    ]
  }
];
